<template>
    <div class="content">
        <p
            v-if="(!slotData.id)"
            class="content-text-info"
        >
            {{ $t("App.RightSlot.SelectArea") }}
        </p>
        <dynamic-table :table-data="slotData.tableData" />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTable.vue"
    import DynamicRightSlotData from "../../../../models/dynamicrighslotdata"
    import ApiService from "@/services/ApiService"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })
    export default class PostiTarkasteleMaaraa extends Vue {
        apiService: ApiService = new ApiService(store.getters.baseHref)
        apiCallBasePart: string = "v1/Viestinta/Posti/Postipalvelut/"

        get slotData(): DynamicRightSlotData | null {
            return (store.getters.rightSlotData as DynamicRightSlotData)
        }
    }
</script>
